import GetRequest from "../utilities/api/get-request";
import PostRequest from "../utilities/api/post-request";
import DeleteRequest from "../utilities/api/delete-request";

class WixProduct {
  // Get products (wix)
  static async get(filterParameters = {}) {
    const path = "/api/products/wix";

    return await GetRequest(path, filterParameters);
  }

  // Import products (wix)
  static async import(data = {}) {
    const path = "/api/products/wix/import";

    return await PostRequest(path, data);
  }

  // Upload wix product to faire
  static async uploadToFaire(productId, taxonomy_type_id) {
    let data = {
      export: [{ product_id: productId }],
      taxonomy_type_id: taxonomy_type_id,
    };
    const path = "/api/products/wix/export";

    return await PostRequest(path, data);
  }

  // Export wix product(s) to faire
  static async export(productIds, taxonomy_type_id) {
    let data = {
      export: productIds,
      taxonomy_type_id: taxonomy_type_id,
    };

    const path = "/api/products/wix/export/bulk";

    return await PostRequest(path, data);
  }

  // Export wix collection(s) to faire
  static async exportCategory(collectionIds, taxonomy_type_id) {
    let data = {
      export: collectionIds,
      taxonomy_type_id: taxonomy_type_id,
    };
    const path = "/api/collections/wix/export/bulk";
    return await PostRequest(path, data);
  }

  // Delete wix product
  static async delete(productId) {
    const path = `/api/products/wix/${productId}`;

    return await DeleteRequest(path);
  }

  // Get wix Store Overview
  static async getWixStoreDetails() {
    const path = "/api/dashboard/wix/detail";

    return await GetRequest(path);
  }
}

export default WixProduct;
